function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.33333 2.66669C7.33333 2.2985 7.63181 2.00002 8 2.00002C8.36819 2.00002 8.66667 2.2985 8.66667 2.66669H7.33333ZM6 2.66669C6 1.56212 6.89543 0.666687 8 0.666687C9.10457 0.666687 10 1.56212 10 2.66669H14V4.00002H2V2.66669H6ZM4 12.6667V6.00002H12V12.6667H4ZM2.66667 4.66669H4H12H13.3333V6.00002V12.6667V14H12H4H2.66667V12.6667V6.00002V4.66669ZM5.82754 7.33335V11.3334H7.16087V7.33335H5.82754ZM8.82754 7.33335V11.3334H10.1609V7.33335H8.82754Z",
  fill: "#220C4A"
});

var SvgTrashIcon = function SvgTrashIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrashIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-icon.2f4622b9.svg";
export { ForwardRef as ReactComponent };